<template>
    <div class="parkRoute">
        <servicesList></servicesList>
        <div class="parkRoute_content">
            <ul class="category_lists">
                <li v-for='(n,i) in service_list.category' :key="i" @click="parkRoute(i)"
                    :class="{ category_active:park_index == i}">{{n.name}}
                </li>
            </ul>
            <span class="route_btn"><img src="../../assets/images/service/start.png" alt=""></span>
            <div class="route_content">
                <div class="routeItem">
                    <div class="routeLeft">
                        <span class="route_line_start"></span><span class="route_num">1</span>
                    </div>
                    <div class="routeRight">
                        <div class="route_item">
                            <div class="route_img_left route_img">
                                <img src="../../assets/images/service/route_bg.png" alt="" class="img_border">
                                <img :src="weburl + routeFirstArr.content" alt="" class="img_content">
                            </div>
                            <span>{{routeFirstArr.name}}</span>
                        </div>
                    </div>
                </div>
                <route-item v-for="(n,i) in contentArr" :route_content="n" :arr-index="i"></route-item>
                <div class="routeItem">
                    <div class="routeLeft">
                        <span class="route_line_end"></span><span class="route_num">{{length-1}}</span>
                    </div>
                    <div class="routeRight">
                        <div class="route_item" v-if="length%2 == '1'">
                            <div class="route_img_left route_img">
                                <img src="../../assets/images/service/route_bg.png" alt="" class="img_border">
                                <img :src='weburl + routeEndArr.content' alt="" class="img_content">
                            </div>
                            <span>{{routeEndArr.name}}</span>
                        </div>
                        <div class="route_item" v-else>
                            <span>{{routeEndArr.name}}</span>
                            <div class="route_img_right route_img">
                                <img src="../../assets/images/service/route_bg.png" alt="" class="img_border">
                                <img :src='weburl + routeEndArr.content' alt="" class="img_content"></div>
                        </div>
                    </div>
                </div>
                <div style="clear: both;"></div>
            </div>
            <span class="route_btn"><img src="../../assets/images/service/end.png" alt=""></span>
        </div>
    </div>
</template>

<script>
import servicesList from "../../components/services/servicesList";
import routeItem from "../../components/services/routeItem";
export default {
  name: "parkRoute",
  components: {
    routeItem,
    servicesList
  },
  data: function() {
    return {
      park_index: 0,
      routeFirstArr: "",
      routeEndArr: "",
      contentArr: "",
      length: ""
    };
  },
  created: function() {
    this.parkRoute(0);
    this.$store.commit("set_current_index", 1);
    this.$store.commit("set_current", 5);
    this.$store.commit("set_title", "nav.service");
  },
  methods: {
    parkRoute(i) {
      this.park_index = i;
      let n = parseInt(i) + parseInt("1");

      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/serve/getRoute",
        dataType: "json",
        data: {
          cid: n,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.$store.commit("set_service_list", res.data.result);
            this.length = res.data.result.route.length;
            this.routeFirstArr = res.data.result.route.shift(); //首项
            this.routeEndArr = res.data.result.route.pop(); //尾项
            this.contentArr = res.data.result.route;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    service_list: function() {
      return this.$store.state.service.service_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/categoryLists";

.parkRoute_content {
  width: 95%;
  margin: auto;
  padding: 10px 0;

  .route_content {
    width: 100%;
    .routeItem {
      width: 100%;
      height: 110px;
    }
    .route_left,
    .route_right {
      float: left;
    }
    .route_left {
      width: 16%;
      margin-right: 2%;
    }
    .route_right {
      width: 82%;
    }
    .routeLeft,
    .routeRight {
      float: left;
    }
    .routeLeft {
      width: 16%;
      margin-right: 2%;
    }
    .routeRight {
      width: 82%;
    }
  }

  .route_btn {
    display: inline-block;
    width: 16%;
    img {
      .img;
    }
  }
}

.category_lists {
  margin-bottom: 5px;
}

@color: #fa5a04;
.routeItem {
  .routeLeft {
    height: 110px;
    line-height: 110px;
    text-align: center;
    display: flex;
    justify-content: center;
    position: relative;
    span {
      display: inline-block;
      width: 3px;
      height: @width;
      background: @color;
      &.route_num {
        background: url(../../assets/images/service/route_icons.png) no-repeat;
        position: absolute;
        top: 39px;
        font-size: @font;
        color: @font-primary;
        width: 32px;
        height: 32px;
        line-height: 28px;
        text-align: center;
        background-size: 32px auto;
      }
    }
  }

  .route_line_start {
    height: 80px !important;
    transform: translateY(30px);
  }

  .route_line_end {
    height: 80px !important;
  }

  .route_line_start:before,
  .route_line_start:after,
  .route_line_end:before,
  .route_line_end:after {
    content: "";
    .border-radius(50%);
  }

  .route_line_start:before,
  .route_line_end:before {
    width: 10px;
    height: 10px;
    background: @color;
  }

  .route_line_start:after,
  .route_line_end:after {
    width: 12px;
    height: 12px;
    border: 1px dashed @color;
  }

  .route_line_start:before {
    top: -10px;
    left: -3px;
    @media (max-width: 320px) {
    }
  }

  .route_line_start:after {
    top: -13px;
    left: -5px;
  }

  .route_line_end:before {
    bottom: 20px;
    left: 26px;
    @media (max-width: 380px) {
      left: 23px;
    }
    @media (max-width: 360px) {
      left: 22px;
    }
    @media (max-width: 320px) {
      left: 20px;
    }
  }

  .route_line_end:after {
    width: 12px;
    height: 12px;
    bottom: 17px;
    left: 24px;
    border: 1px dashed @color;
    @media (max-width: 380px) {
      left: 21px;
    }
    @media (max-width: 360px) {
      left: 20px;
    }
    @media (max-width: 320px) {
      left: 18px;
    }
  }
  .routeRight {
    width: @width;
    .route_item {
      height: 110px;
      line-height: 110px;
      span {
        display: inline-block;
        text-align: center;
        width: 49%;
        font-size: @font;
        @media (min-width: 768px) {
          font-size: @font + 0.4;
        }
      }
      .route_img_left {
        float: left;
        &:extend(.img_content);
      }
      .route_img_right {
        float: right;
        &:extend(.img_content);
      }
      .img_content {
        height: 100px;
        position: absolute;
        top: 4px;
        left: 4px;
        z-index: 98;
        .border-radius(50%);
      }
      .route_img {
        height: 110px;
        width: 40%;
        margin: 0 5%;
        position: relative;
        .img_border {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
          width: 110px;
        }
      }
    }
  }
}
</style>
